class RcInstagramAutoMedia extends HTMLElement {
  connectedCallback() {
    if (this.dataset.rcInstagramInitialized === 'true') return;
    this.dataset.rcInstagramInitialized = 'true';

    const slide = this.closest('.slideshow__slide');
    if (!slide) return;

    const selectionMode = this.dataset.selectionMode;
    const fallback = this.querySelector('template[data-rc-instagram-fallback]');

    if (selectionMode === 'random') {
      const candidates = Array.from(this.querySelectorAll('template[data-rc-instagram-candidate]'))
        .filter((candidate) => this.isEligibleForCurrentViewport(candidate));
      const selected = candidates.length > 0 ? candidates[this.randomIndex(candidates.length)] : fallback;
      this.activateTemplate(selected);
    } else if (selectionMode === 'fixed-viewport') {
      const candidate = this.querySelector('template[data-rc-instagram-fixed-candidate]');
      const selected = candidate && this.isEligibleForCurrentViewport(candidate) ? candidate : fallback;
      this.activateTemplate(selected);
    }

    const mediaType = this.dataset.selectedMediaType === 'video' ? 'video' : 'image';
    slide.setAttribute('media-type', mediaType);

    const volumeControl = slide.querySelector('[data-rc-instagram-volume-control]');
    if (volumeControl) volumeControl.hidden = mediaType !== 'video';

    this.unwrapIntoPrestigeMediaSlot();
  }

  activateTemplate(template) {
    if (!template) return;
    this.dataset.selectedMediaType = template.dataset.mediaType || 'image';
    this.replaceChildren(template.content.cloneNode(true));
  }

  unwrapIntoPrestigeMediaSlot() {
    const fragment = document.createDocumentFragment();
    while (this.firstChild) fragment.appendChild(this.firstChild);
    this.replaceWith(fragment);
  }

  isEligibleForCurrentViewport(candidate) {
    const isMobile = window.matchMedia('(max-width: 699px)').matches;
    const quality = isMobile ? candidate.dataset.mobileQuality : candidate.dataset.desktopQuality;
    return quality === 'PASS' || quality === 'CONDITIONAL';
  }

  randomIndex(length) {
    if (length <= 1) return 0;

    if (window.crypto?.getRandomValues) {
      const values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return values[0] % length;
    }

    return Math.floor(Math.random() * length);
  }
}

if (!window.customElements.get('rc-instagram-auto-media')) {
  window.customElements.define('rc-instagram-auto-media', RcInstagramAutoMedia);
}
